import LocalStorageImpl from '@/serviceImpl/LocalStorageImpl';

const isLoggedUseCase = (): boolean => {

  const token = LocalStorageImpl.getCredentials();

  return !!token;
};

export default isLoggedUseCase;